import React, { useCallback, useState } from 'react';

import { format } from 'date-fns';

import { FaWhatsapp, FaCheckCircle, FaSpinner, FaCircle } from 'react-icons/fa';
import { Button } from 'react-bootstrap';

import { useToast } from '../../../../hooks/toast';

import getResponseErrors from '../../../../utils/getResponseErrors';

import { PacienteLinha, PacienteLista } from '../styles';
import { htmlDecode } from '../../../../utils/funcoes';
import { IListagemVencendo } from '..';
import api from '../../../../services/api';
import { Spinner } from '../../../../components/Agendamento/styles';

type ITemTabela = {
  contaPR: IListagemVencendo;
};

const ItemTabela: React.FC<ITemTabela> = ({ contaPR }) => {
  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);
  const [dataUltimoEnvioFormatado, setDataUltimoEnvioFormatado] = useState(
    contaPR.LemDataFormatado,
  );

  const handleSalvaLembrete = useCallback(async () => {
    try {
      setLoading(true);
      const dados = {
        LemCprCodigo: contaPR.CprCodigo,
        LemMetodo: 'Whatsapp',
      };
      await api.post(`/pagamento/lembrete`, dados);
      setDataUltimoEnvioFormatado(format(new Date(), 'dd/MM/yyyy HH:mm'));
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível salvar a lembrete',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, contaPR.CprCodigo]);

  const handleEnviaLembrete = useCallback((contapr: IListagemVencendo) => {
    const textoDecode = htmlDecode(contapr.textoMensagem || '');
    const textoMensagem = encodeURIComponent(textoDecode);

    const linkWhatsapp = `https://api.whatsapp.com/send?phone=55${contapr?.celular}&text=${textoMensagem}`;
    window.open(linkWhatsapp, '_blank');
  }, []);

  return (
    <>
      <PacienteLinha
        className="row no-gutters"
        key={`cpr-${contaPR.CprCodigo}`}
        data-id={contaPR.CprCodigo}
      >
        <div className="col-md-1 col-lg-1">
          <PacienteLista>{contaPR.PlaNumero}</PacienteLista>
        </div>
        <div className="col-md-2 col-lg-5">
          <PacienteLista>{contaPR.nomePaciente}</PacienteLista>
        </div>
        <div className="col-md-1 col-lg-1">
          <PacienteLista>{contaPR.CprDataVencFormatado}</PacienteLista>
        </div>
        <div className="col-md-2 col-lg-1">
          <PacienteLista>{contaPR.telefone}</PacienteLista>
        </div>
        <div className="col-md-2 col-lg-1">
          <PacienteLista>{contaPR.celular}</PacienteLista>
        </div>
        <div className="col-md-2 col-lg-1">
          <PacienteLista>{dataUltimoEnvioFormatado}</PacienteLista>
        </div>
        <div className="col-md-2 col-lg-1">
          <PacienteLista>
            <Button
              type="button"
              variant="success"
              size="sm"
              className="ml-1"
              data-id={contaPR.CprCodigo}
              onClick={() => handleEnviaLembrete(contaPR)}
            >
              <FaWhatsapp size={16} />
            </Button>

            {loading ? (
              <Spinner className="px-2 py-1 border rounded ml-1">
                <FaSpinner size={17} />
              </Spinner>
            ) : (
              <Button
                type="button"
                variant={
                  dataUltimoEnvioFormatado !== ''
                    ? 'success'
                    : 'outline-secondary'
                }
                size="sm"
                className="ml-1"
                data-id={contaPR.CprCodigo}
                onClick={() => handleSalvaLembrete()}
              >
                {dataUltimoEnvioFormatado !== '' ? (
                  <FaCheckCircle size={16} />
                ) : (
                  <FaCircle size={16} />
                )}
              </Button>
            )}
          </PacienteLista>
        </div>
      </PacienteLinha>
    </>
  );
};

export default ItemTabela;
